module.exports = __webpack_public_path__ + "static/media/expertise-operations.c917e835.jpg";